<template>
  <div
    id="layout-default"
    :class="{enlarged:this.$bus.sidebarStatus}"
  >
    <top-bar />
    <side-bar :slide-menu-items="slideMenuItems" />
    <content-wrap />
  </div>
</template>
<script>
    import ContentWrap from "@/ContentWrap";
    import TopBar from "@/TopBar";
    import SideBar from "@/SideBar";
    import SlideMenuItems from "@/lib/SidebarItems"

    export default {
        name: 'LayoutDefault',
        components: {SideBar, TopBar, ContentWrap},
        data () {
            return {
                slideMenuItems: SlideMenuItems
            }
        }
    }
</script>
<style scoped>
    #layout-default {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
